import { mix, observable, pipe, watch } from "@chorda/core";
import { createReactRenderer } from "@chorda/react";
const renderer = createReactRenderer();
export const withReact = (props) => {
    return mix({
        defaults: {
            preactRoot: () => observable(null),
            $renderer: () => renderer,
        },
        injections: {
            parentEl: $ => $.$context.$dom,
            $pipe: $ => pipe($.$patcher, $.$renderer),
        },
        events: {
            afterInit: (html, { preactRoot }) => {
                preactRoot.$value = html;
            }
        },
        joints: {
            connectToContextDom: ({ preactRoot, parentEl, $renderer }) => {
                watch(() => {
                    if (parentEl.$value) {
                        console.log('react attach');
                        $renderer.attach(parentEl.$value, preactRoot.$value);
                    }
                    else {
                        console.log('react detach');
                        $renderer.detach(preactRoot.$value);
                    }
                }, [parentEl]);
            }
        },
    }, props);
};
